/*eslint-disable no-useless-catch*/
// Importar dependencias
import ApiClient from "./ApiClient";

const stockUrl = "stocks/";

// Obtiene un inventario por el id del producto y la sucursal
async function getByProductIdAndBranchId(productId, branchId) {
  try {
    const response = await ApiClient.get(
      stockUrl + `?productId=${productId}&branchId=${branchId}`
    );

    return response.data;
  } catch (err) {
    throw new Error(err.response.data.message);
  }
}

// Función para obtener los productos de una sucursal
// ====================> UPDATE: Se obtienen los STOCKS, no los productos <===================
async function getProductsByBranchId(branchId) {
  // Realizamos la petición
  try {
    const response = await ApiClient.get(stockUrl + "branches/" + branchId);
    return response.data;
  } catch (err) {
    // Si algo sale mal, regresa el error
    throw new Error(err.response.data.message);
  }
}

// Función para obtener las sucursales de un producto
async function getBranchesByProductId(productId) {
  // Realizamos la petición
  try {
    const branchesInProduct = await ApiClient.get(
      `${stockUrl}products/${productId}`
    );

    return branchesInProduct.data;
  } catch (err) {
    // Si algo sale mal, regresa un error
    throw new Error(err.response.data.message);
  }
}

// Función para agregar varias sucursales a un producto
async function addProductToBranches(productId, branchesId) {
  // Almacenamos los responses
  let response = [];
  // Realizamos la petición
  try {
    branchesId.map(branchId => {
      const resultItem = addProductToBranch(productId, branchId);
      response.push(resultItem);
    });
    return response;
  } catch (err) {
    throw new Error(err.response.data.message);
  }
}

// Crea inventarios con una cantidad
async function createStocksWithQuantity(productId, stocksData) {
  try {
    // Iterar por los datos de inventarios
    for (let i = 0; i < stocksData.length; i += 1) {
      // Obtener datos de cada inventario
      const stockData = stocksData[i];
      const branchId = stockData._id;
      const quantity = stockData.quantity;

      // Crear inventario
      const result = await ApiClient.post(stockUrl, {
        branchId,
        productId,
        quantity
      });
    }
  } catch (err) {
    throw new Error(err.response.data.message);
  }
}

// Funcion para agregar una sucursal a un producto
async function addProductToBranch(productId, branchId) {
  try {
    // Generamos la peticion
    let branch = await ApiClient.post(stockUrl, {
      branchId: branchId,
      productId: productId
    });
    return branch;
  } catch (err) {
    // Si algo sale mal, regresa el error
    throw new Error(err.response.data.message);
  }
}

// Función para eliminar varias sucursales de un producto
async function removeBranchesToProduct(productId, branchesId) {
  // Almacenamos las respuestas
  let result = [];

  // Realizamos petición
  try {
    for (let i = 0; branchesId.length > i; i += 1) {
      const resultItem = await removeBranchToProduct(productId, branchesId[i]);

      result.push(resultItem);
    }
  } catch (err) {
    // Si algo sale mal, regresa el error
    throw new Error(err.response.data.message);
  }
}

// Función para eliminar una sucursal de un producto
async function removeBranchToProduct(productId, branchId) {
  // Realizamos petición
  try {
    let result = await ApiClient.delete(stockUrl, {
      data: {
        productId,
        branchId
      }
    });
    return result;
  } catch (err) {
    // Si algo sale mal, regresa el error
    throw new Error(err.response.data.message);
  }
}

// Función para modificar el número de items que tiene un stock
async function updateStock(stockId, quantity) {
  // Realizamos la petición
  try {
    const response = await ApiClient.patch(stockUrl + stockId + "/quantity", {
      quantity
    });
    return response;
  } catch (err) {
    // Si algo sale mal, regresa el error
    throw new Error(err.response.data.message);
  }
}

// Función para obtener el inventario de un negocio
async function getStocksByBusiness(businessId) {
  // Realizamos la petición
  try {
    const response = await ApiClient.get(`${stockUrl}business/${businessId}`);
    return response.data.branches;
  } catch (err) {
    // Si algo sale mal, regresa el error
    throw new Error(err.response.data.message);
  }
}

// Exportamos las funciones
export default {
  getByProductIdAndBranchId,
  createStocksWithQuantity,
  getBranchesByProductId,
  getProductsByBranchId,
  addProductToBranches,
  addProductToBranch,
  removeBranchesToProduct,
  removeBranchToProduct,
  getStocksByBusiness,
  updateStock
};
